
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
Group,
Cell
},
data () {
return {




msg: 'Hello World!'
}
}
}



// WEBPACK FOOTER //
// ./src/views/order.vue